var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout"},[_c('div',{staticClass:"md-layout-item md-size-100"},[_c('h2',[_vm._v("欢迎回来，"+_vm._s(_vm.$user.name))])])])}
var staticRenderFns = []

export { render, staticRenderFns }